import { createContext } from 'react';
import * as mtLinks from 'src/configs/mtLinks';

const MtLinksContext = createContext<mtLinks.types.Config>(mtLinks.constants.production);

const { Provider: MtLinksProvider } = MtLinksContext;

export { MtLinksContext, MtLinksProvider };
